import { userInfoStore } from '../../store/userInfoStore';

export const exchangeAmount = (amount) => {
  const { rate, precision } = userInfoStore;
  const amountPrecision = 10 ** +precision > 1 ? 10 ** +precision : 100;
  return Math.trunc((amount / +rate) * amountPrecision) / amountPrecision;
};
